import React, { useState } from "react";
import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

// Sun wiggle animation
const sunWiggle = keyframes`
  0% { transform: rotate(-10deg) scale(1); }
  20% { transform: rotate(10deg) scale(1.08);}
  40% { transform: rotate(-8deg) scale(1.05);}
  60% { transform: rotate(8deg) scale(1.1);}
  80% { transform: rotate(-5deg) scale(1.07);}
  100% { transform: rotate(0deg) scale(1);}
`;

const SunEmoji = styled.div`
  font-size: 3.2rem;
  margin: 0 auto 6px auto;
  animation: ${sunWiggle} 2.2s infinite;
  display: inline-block;
`;

const navBtnStyle = {
  background: "#FFD166",
  border: "none",
  borderRadius: 16,
  padding: "8px 20px",
  fontWeight: 600,
  cursor: "pointer",
  marginRight: 10,
  fontSize: "1em"
};

const cuteBtnStyle = {
  borderRadius: 20,
  padding: "12px 32px",
  background: "#FFD166",
  color: "#222",
  fontWeight: 600,
  border: "none",
  cursor: "pointer",
  fontSize: "1.08em",
  marginTop: 10,
  boxShadow: "0 2px 8px rgba(255,209,102,0.09)",
  transition: "background 0.2s"
};

export default function VitaminDTracker({ user, onRecord }) {
  const [sunlight, setSunlight] = useState(false);
  const [foods, setFoods] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const navigate = useNavigate();

  // Navigation handlers
  const goHome = () => navigate("/");
  const goBack = () => window.history.length > 1 ? navigate(-1) : navigate("/");

  const handleSave = async () => {
    const today = new Date().toISOString().slice(0, 10);
    const entry = { date: today, sunlight, foods };
    setSubmitted(true);
    if (user) {
      await updateDoc(doc(db, "userProblems", user.uid), {
        vitaminDLogs: arrayUnion(entry)
      });
      if (onRecord) onRecord(entry);
    }
    setTimeout(() => setSubmitted(false), 2000);
    setSunlight(false);
    setFoods("");
  };

  return (
    <div style={{
      maxWidth: 500,
      margin: "40px auto",
      background: "#fffbe6",
      borderRadius: 24,
      boxShadow: "0 2px 12px rgba(255,209,102,0.10)",
      padding: 32,
      textAlign: "center",
      border: "2px solid #ffe29a"
    }}>
      {/* Navigation Buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginBottom: 10 }}>
        <button onClick={goBack} style={navBtnStyle}>← Back</button>
        <button onClick={goHome} style={navBtnStyle}>🏠 Home</button>
      </div>
      <SunEmoji>☀️</SunEmoji>
      <h2 style={{ marginBottom: 6 }}>Vitamin D Tracker</h2>
      <div style={{ fontSize: "1.1em", color: "#b48b1e", marginBottom: 12 }}>
        Track your sunshine &amp; vitamin D foods!
      </div>
      <div style={{ margin: "24px 0" }}>
        <label>
          <input
            type="checkbox"
            checked={sunlight}
            onChange={e => setSunlight(e.target.checked)}
          />{" "}
          I got at least 10 minutes of sunlight today
        </label>
      </div>
      <div style={{ margin: "24px 0" }}>
        <input
          type="text"
          value={foods}
          onChange={e => setFoods(e.target.value)}
          placeholder="Vitamin D-rich foods eaten (e.g. 🥚 🐟 🧀 🥛)"
          style={{ width: "80%", padding: 10, borderRadius: 8, border: "1px solid #ccc" }}
        />
      </div>
      <button
        style={cuteBtnStyle}
        onClick={handleSave}
      >
        Save Entry
      </button>
      {submitted && (
        <div style={{ color: "#27ae60", marginTop: 10, fontWeight: 600 }}>
          Entry saved!
        </div>
      )}
    </div>
  );
}
